export const PLATFORMS = {
  linkedin: { label: "LinkedIn", color: "#0A66C2", charLimit: 3000 },
  instagram: { label: "Instagram", color: "#C13584", charLimit: 2200 },
  x: { label: "X", color: "#111111", charLimit: 280 },
  tiktok: { label: "TikTok", color: "#00B8B0", charLimit: 2200 },
  facebook: { label: "Facebook", color: "#1877F2", charLimit: 63206 },
};

export const STATUS_META = {
  draft: { label: "Draft", cls: "bg-slate-100 text-slate-600 border-slate-200" },
  pending_approval: { label: "In Review", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  changes_requested: { label: "Changes Requested", cls: "bg-orange-50 text-orange-700 border-orange-200" },
  approved: { label: "Approved", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  rejected: { label: "Rejected", cls: "bg-red-50 text-red-600 border-red-200" },
  posted: { label: "Posted", cls: "bg-indigo-50 text-indigo-700 border-indigo-200" },
};

export const StatusBadge = ({ status }) => {
  const m = STATUS_META[status] || STATUS_META.draft;
  return (
    <span data-testid={`status-badge-${status}`} className={`inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-medium border ${m.cls}`}>
      {m.label}
    </span>
  );
};

export const PlatformChip = ({ platform }) => {
  const p = PLATFORMS[platform] || { label: platform, color: "#666" };
  return (
    <span className="inline-flex items-center gap-1.5 text-[11px] font-medium text-slate-600">
      <span className="w-2 h-2 rounded-full" style={{ background: p.color }} />
      {p.label}
    </span>
  );
};
